import React from 'react'
import ButtonComponent from '../../../../components/Buttons/ButtonComponent';

import Grid from '@mui/material/Grid';
const ButtonRegUserEntity = ({ dataRegUserAccess = [], reloadData, handleAdd }) => {
    return (
        <div className="row">
            <div className='col-12'>
                <Grid container item spacing={1} direction="row" style={{ 'maxWidth': '100vw', margin: '0px', columnGap: '8px', rowGap: '10px' }}>
                    {ButtonComponent.ReloadButton(reloadData)}
                    {dataRegUserAccess.map((elm) => (
                        <>
                            {elm.accessCode === 'CRE' && ButtonComponent.AddButton(handleAdd, 'User Entity')}
                        </>
                    ))}
                </Grid>
            </div>
        </div>
    )
}

export default ButtonRegUserEntity